export default __webpack_public_path__ + "static/media/sv22_kr_star_b1.87ebdb50.mp3";